import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27cdea02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-quantity-entries" }
const _hoisted_2 = {
  key: 0,
  class: "entries-label"
}

import { recProps } from '../../mixins/rec-component';
  import ScoreItemQuantity from '../score-item-quantity.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-quantity-entries',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.description.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.description.label), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.description.entries || []), (entry) => {
      return (_openBlock(), _createBlock(ScoreItemQuantity, {
        key: entry.id,
        readonly: "",
        "model-value": entry.count,
        "date-from": entry.date_from,
        "date-to": entry.date_to
      }, null, 8, ["model-value", "date-from", "date-to"]))
    }), 128))
  ]))
}
}

})